// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path d="M18.5,4h-13C4.7,4,4,4.7,4,5.5v13C4,19.3,4.7,20,5.5,20h10.2l4.3-4.3V5.5C20,4.7,19.3,4,18.5,4z M5,18.5v-13
		C5,5.2,5.2,5,5.5,5h13C18.8,5,19,5.2,19,5.5V15h-2.5c-0.8,0-1.5,0.7-1.5,1.5V19H5.5C5.2,19,5,18.8,5,18.5z M18.3,16L16,18.3v-1.8
		c0-0.3,0.2-0.5,0.5-0.5H18.3z M16,9H8V8h8V9z M16,11H8v-1h8V11z M14,12v1H8v-1H14z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-note-DxrmfuMN.js.map
